import { loadUnitFrameScale } from "../prefs.js";

export type UnitFrameAnchor = "left" | "right";

export function unitFramePx(base: number): number {
  return Math.ceil(base * loadUnitFrameScale());
}

export function unitFrameStyle(anchor: UnitFrameAnchor): { readonly transform: string; readonly transformOrigin: string } {
  const scale = loadUnitFrameScale();
  return { transform: `scale(${String(scale)})`, transformOrigin: anchor === "left" ? "top left" : "top right" };
}
